import { Badge, BadgeProps, Box, Flex } from '@chakra-ui/react';
import { ReactComponent as UpgradeIcon } from 'assets/icons/crown_upgrade_fill.svg';

import { UserType, UserTypes } from '../../user.types';

interface PermissionBadgeProps extends BadgeProps {
  permission: UserType;
  showIcon?: boolean;
  showTextOnHover?: boolean;
}

const expandStyle = { display: 'flex' };

export const PermissionBadge = ({
  permission,
  showIcon = true,
  showTextOnHover = true,
  ...otherProps
}: PermissionBadgeProps) => {
  const color = permission === UserTypes.Business ? 'font.500' : 'white';
  const backgroundColor = permission === UserTypes.Business ? 'yellow.500' : 'avatar.3';
  return (
    <Badge
      variant={'solid'}
      display='flex'
      color={color}
      backgroundColor={backgroundColor}
      paddingX={2}
      textTransform={'capitalize'}
      minWidth={'min-content'}
      borderRadius={'base'}
      fontWeight={'medium'}
      role='group'
      {...otherProps}
    >
      <Flex gap={1} alignItems='center' as='span'>
        {showIcon && <UpgradeIcon color={color} width='14' />}
        <Box
          display={showTextOnHover ? 'none' : 'inherit'}
          _groupHover={expandStyle}
          _groupFocus={expandStyle}
          _groupFocusWithin={expandStyle}
          as='span'
        >
          {permission}
        </Box>
      </Flex>
    </Badge>
  );
};
